class Data {
    // static videos() {
    //     if (undefined !== process.env.DATA_YEAR && undefined !== process.env.DATA) {
    //         // expected file in src/data in format videos.{{DATA}}.{{DATA_YEAR}}.json
    //         return import(`../data/videos.${process.env.DATA}.${process.env.DATA_YEAR}.json`);
    //     }
    //     // Legacy default videos to load, for example if YEAR is not defined, still expects DATA to be defined
    //     return import(`../data/videos.${process.env.DATA}.json`);
    // }

    static videosForLive(year, type) {
        
        return import(`../data/videos.${type}.${year}.json`).then((data) => {
            console.log(data);
            return data;
        }).catch((error) => {
            var t = {questions:{}};
            return t;
        })
    }


    // static resources() {
    //     // Legacy default resources to load, for example if YEAR is not defined, still expects DATA to be defined
    //     if (process.env.LANDING) {
    //         // No data needed if landing app
    //         return [];
    //     }
    //     if (undefined !== process.env.DATA_YEAR && undefined !== process.env.DATA) {
    //         // expected file in src/data in format videos.{{DATA}}.{{DATA_YEAR}}.json
    //         return import(`../data/resources.${process.env.DATA}.${process.env.DATA_YEAR}.json`);
    //     }
    //     return import(`../data/resources.${process.env.DATA}.json`);
    // }


}

export default Data;



// WEBPACK FOOTER //
// ./src/plugins/data.js